const FontFamilyBold = "DMSans-Bold";
const FontFamilyRegular = "DMSans-Regular";

export {
  FontFamilyBold,
  FontFamilyRegular
}